<template>
  <section>
    <div>
      <div class="table_top_div" style="margin-bottom: 5px">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <span style="font-size: 18px; font-weight: bold; display: inline-block; color: #6170d7">
            {{ list_details.hospitalName }}
          </span>
          <el-tag :type="list_details.isReportedThisWeek ? 'success' : 'danger'">
            {{ list_details.isReportedThisWeek ? '已填报' : '未填报' }}
          </el-tag>
        </div>
      </div>
      <!-- <div class="table_top_div" style="margin-bottom: 5px"></div> -->
      <div class="table_top_div" style="margin-bottom: 5px; box-sizing: border-box; padding: 10px">
        <!-- <el-collapse>
          <el-collapse-item style="font-size: 20px" title="上月手术量" name="3"> -->
        <el-table
          :data="mobile_ssl_list.list"
          :border="true"
          :cell-style="cellStyle4new"
          cell-class-name="cell_class_name"
          :span-method="objectSpanMethod4"
          max-height="100%"
          header-cell-class-name="header_cell_name"
          highlight-current-row
          v-loading="listLoading"
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="categoryName" label="Category" width=""></el-table-column>
          <el-table-column label="汇总" width="80">
            <template slot-scope="scope">
              <el-input
                v-model="mobile_ssl_list.totalNumber"
                class="border_none"
                placeholder="请填写"
                :placeholder="mobile_ssl_list.referTotalNumber"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column style="position: relative" prop="number" :label="'全院' + old_Month + '月预估总手术量'">
            <template slot-scope="scope">
              <div style="position: relative">
                <!-- <span style="font-size: 10px; color: darkgrey; position: absolute; z-index: 99999999; width: 100%; top: -10px">预估值:20009</span> -->
                <el-input
                  type="number"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  v-model="scope.row.number"
                  class="border_none"
                  :placeholder="scope.row.referNumber"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="jjsvytd" label="JJSV YTD 预估手术量"></el-table-column> -->
          <el-table-column prop="jjsvNumber" :label="'JJSV ' + old_Month + '月预估手术量'"></el-table-column>
        </el-table>
        <!-- <div
              v-if="!list_details.isReportedThisWeek"
              type="primary"
              @click="dialogVisible = true"
              style="
                color: #6170d7;
                width: 100%;
                font-size: 16px;
                padding: 5px 0 !important;
                margin-bottom: 10px;
                background-color: white;
                text-align: center;
                box-sizing: border-box;
                border: #6170d7 2px dashed;
                border-radius: 8px;
                margin-top: 10px;
              "
            >
              <span style="font-size: 20px">+</span>
              添加上报产品
            </div>
            <div v-for="tables in all_LWSurgeries_list">
              <el-table
                :data="tables"
                :border="true"
                cell-class-name="cell_class_name"
                max-height="100%"
                header-cell-class-name="header_cell_name"
                highlight-current-row
                v-loading="listLoading"
                :cell-style="cellStyle4"
                style="width: 100%; margin-top: 10px"
              >
                <el-table-column prop="product" label="Product">
                  <template slot-scope="scope">
                    {{ prdouct_JJSV.includes(scope.row.product) ? scope.row.product : 'MKT-' + scope.row.product }}
                  </template>
                </el-table-column>
                <el-table-column prop="totalSurgeries" label="YTD手术量"></el-table-column>
                <el-table-column prop="lastWeekSurgeries" label="上月手术量">
                  <template slot-scope="scope">
                    <span v-if="scope.row.category == 'JJSV'">{{ scope.row.lastWeekSurgeries }}</span>
                    <el-input
                      v-else
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                      v-model="scope.row.lastWeekSurgeries"
                      class="border_none"
                      placeholder="请填写"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table> -->
        <!-- </div> -->
        <!-- </el-collapse-item>
          <el-collapse-item title="DRG/DIP费用" name="0">
            <el-form style="margin-top: 10px" label-width="80px">
              <el-form-item label="drg">
                <span slot="label">
                  <span style="font-weight: bold">DRG费用</span>
                </span>
                <el-input v-model="list_details.drg"></el-input>
              </el-form-item>
              <div style="height: 10px"></div>
              <el-form-item label="dip">
                <span slot="label">
                  <span style="font-weight: bold">DIP费用</span>
                </span>
                <el-input v-model="list_details.dip"></el-input>
              </el-form-item>
            </el-form>
          </el-collapse-item>
          <el-collapse-item title="国采签约量" name="1">
            <el-table
              :data="unit_list"
              :border="true"
              cell-class-name="cell_class_name"
              max-height="100%"
              :cell-style="cellStyle2"
              header-cell-class-name="header_cell_name"
              highlight-current-row
              v-loading="listLoading"
              style="width: 100%; margin-top: 10px"
            >
              <el-table-column prop="Category" label="Category"></el-table-column>
              <el-table-column prop="JJSV_contractQuantity" label="JJSV">
                <template slot-scope="scope">
                  {{ scope.row.Category == '三焦点(散+非散)' ? '/' : scope.row.JJSV_contractQuantity }}
                </template>
              </el-table-column>
              <el-table-column prop="Market_contractQuantity" label="Market">
                <template slot-scope="scope">
                  <el-input
                    onkeyup="value=value.replace(/[^\d]/g,'')"
                    v-model="scope.row.Market_contractQuantity"
                    class="border_none"
                    placeholder="请填写"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
          <el-collapse-item title="本年分品类潜力" name="2">
            <el-table
              :data="potential_list"
              :border="true"
              cell-class-name="cell_class_name"
              max-height="100%"
              :span-method="objectSpanMethod"
              :cell-style="cellStyle3"
              header-cell-class-name="header_cell_name"
              highlight-current-row
              v-loading="listLoading"
              style="width: 100%; margin-top: 10px"
            >
              <el-table-column prop="Category" label="Category"></el-table-column>
              <el-table-column prop="productCategory" label="全院总手术量">
                <template slot-scope="scope">
                  {{ list_details.potential }}
                </template>
              </el-table-column>
              <el-table-column prop="potential" label="Market">
                <template slot-scope="scope">
                  <el-input
                    onkeyup="value=value.replace(/[^\d]/g,'')"
                    v-model="scope.row.potential"
                    @blur="total_pnl()"
                    class="border_none"
                    placeholder="请填写"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse> -->
      </div>
    </div>
    <div style="font-size: 12px">注：本页的预估手术量是基于销售的跟台观察和既往的医院耗用所做出的估测</div>
    <el-button type="primary" v-preventReClick="3000" @click="subimit" style="color: white; width: 100%; font-size: 16; margin-top: 20px">
      确认上报
    </el-button>

    <el-dialog title="请选择产品" :visible.sync="dialogVisible" width="30%">
      <el-select v-model="select_product" style="width: 100%" placeholder="请选择">
        <el-option v-for="item in jjsv_select_product_list" :label="item" :value="item"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="select_sjl(select_product)">添 加</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '@/../util/date'
import { cataractnnvmp_getjjsvproduct, cataractnnvmp_getmarketproduct, cataractnnvmp_mobilesubmit, cataractnnvmp_mobiledetailed } from '@/api/api'
import { getButtonList } from '@/promissionRouter'
import { quillEditor } from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
import Toolbar from '@/components/Toolbar'
import Approve from '@/components/Approve'

export default {
  components: { Toolbar, quillEditor, Approve },
  data() {
    return {
      old_Month: '',
      next_Month: '',
      now_Month: '',
      select_cells_if: false,
      mobile_ssl_list: [],
      jjsv_select_product_list: ['景深延长(散+非散)', '三焦点(散+非散)', '双焦(散+非散)', '单焦散光', '单焦非散'],
      prdouct_JJSV: ['ZXT00', 'ZXR00', 'ZFR00v', 'DFW00', 'ZMB00', 'ZMT00', 'ZCT00', 'ZCU00', 'ICB00', 'DCB00', 'DIB00', 'DIU00', 'ZCB00', 'Others'],
      prdouct: [
        {
          JJSV: ['ZXT00', 'ZXR00', 'ZFR00v', 'DFW00'],
          Market: ['景深延长(散+非散)'],
        },
        {
          JJSV: ['ZXT00', 'ZXR00', 'ZFR00v', 'DFW00'],
          Market: ['三焦点(散+非散)'],
        },
        {
          JJSV: ['ZMB00', 'ZMT00'],
          Market: ['双焦(散+非散)'],
        },
        {
          JJSV: ['ZCT00', 'ZCU00', 'DIU00'],
          Market: ['单焦散光'],
        },
        {
          JJSV: ['ICB00', 'DCB00', 'DIB00', 'ZCB00', 'Others'],
          Market: ['单焦非散'],
        },
      ],
      select_product: '',
      dialogVisible: false,
      listLoading: false,
      tabel_list: [],
      unit_list: [],
      potential_list: [],
      isMobile: false,
      list_details: [],
      market_select_product_list: [],
      all_LWSurgeries_list: [],
      record_product: [],
      unit_style_list: [],
      lastWeekSurgeries_style_list: [],
      lastWeekSurgeries_msg: [],
      unit_msg: [],
    }
  },
  watch: {
    mobile_ssl_list: {
      handler(newVal) {
        var all_number = 0
        console.log(this.mobile_ssl_list)
        let mobile_ssl_list = this.mobile_ssl_list.list
        for (var i in mobile_ssl_list) {
          all_number += Number(mobile_ssl_list[i].number)
        }
        this.all_number = all_number
        console.log(all_number)
        console.log(this.all_number)
      },
      deep: true,
    },
  },
  methods: {
    cellStyle4new({ row, column, rowIndex, columnIndex }) {
      if (column.label == 'JJSV YTD 预估手术量' || column.label == 'JJSV ' + this.old_Month + '月预估手术量') {
        return {
          'background-color': '#f6f9ff',
        }
      }

      if (!this.select_cells_if) {
        return
      }
      if (row.number < row.jjsvNumber && column.label === '全院' + this.old_Month + '月预估总手术量') {
        return { backgroundColor: '#eca5a5' }
      }
      //   if (this.all_number > this.mobile_ssl_list.totalNumber && column.label === '汇总') {
      //     return { backgroundColor: '#eca5a5' }
      //   }
    },
    back_url() {
      //   this.$router.replace({ path: this.$route.query.back_url })
      this.$router.go(-1)
    },
    lastWeekSurgeries_style_un() {
      this.lastWeekSurgeries_style_list = []
      this.lastWeekSurgeries_msg = []
      this.all_LWSurgeries_list.filter((item) => {
        let makt_num = 0
        let jjsv_num = 0
        let label_list = []
        let makt_label = []
        let jjsv_label = []
        item.filter((item2) => {
          label_list.push(item2.product)
          console.log(item2)
          if (item2.category == 'JJSV' && item2.lastWeekSurgeries != null) {
            jjsv_label.push(item2.product)
            jjsv_num += Number(item2.lastWeekSurgeries)
          }
          if (item2.category == 'Market' && item2.lastWeekSurgeries != null) {
            makt_label.push(item2.product)
            makt_num += Number(item2.lastWeekSurgeries)
          }
        })
        if (makt_num < jjsv_num) {
          this.lastWeekSurgeries_style_list = [...this.lastWeekSurgeries_style_list, ...label_list]
          this.lastWeekSurgeries_msg.push('Market【' + makt_label.join('+') + '】值不能小于 JJSV 对应值。')
        }
      })
      if (this.lastWeekSurgeries_style_list.length > 0) {
        return false
      }
      return true
    },
    lastWeekSurgeries_style_un_new() {
      let mobile_ssl_list = this.mobile_ssl_list.list
      var ifs = 0
      var all_number = 0
      for (var i in mobile_ssl_list) {
        if (mobile_ssl_list[i].number < mobile_ssl_list[i].jjsvNumber) {
          ifs = 1
        }
        all_number += Number(mobile_ssl_list[i].number)
      }
      this.all_number = all_number
      if (this.all_number > this.mobile_ssl_list.totalNumber) {
        ifs = ifs == 1 ? 3 : 2
      }
      return ifs
    },
    async subimit(e) {
      this.select_cells_if = true
      console.log(this.lastWeekSurgeries_style_un_new())
      if (this.lastWeekSurgeries_style_un_new() != 0) {
        var text = [
          '全院' + this.old_Month + '月预估总手术量不能小于JJSV' + this.old_Month + '月预估手术量对应值。',
          '全院' + this.old_Month + '月预估总手术量不能大于汇总',
          '全院' +
            this.old_Month +
            '月预估总手术量不能小于JJSV' +
            this.old_Month +
            '月预估手术量对应值。<br/>全院' +
            this.old_Month +
            '月预估总手术量不能大于汇总',
        ]

        //   var texts = 'text3'
        // this.lastWeekSurgeries_msg.push('Market值不能小于 JJSV 对应值。')
        this.$alert(text[Number(this.lastWeekSurgeries_style_un_new()) - 1], '提示', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true,
        })
        return
      }
      //   if (!this.lastWeekSurgeries_style_un()) {
      //     this.$alert(this.lastWeekSurgeries_msg.join('</br>'), '提示', {
      //       confirmButtonText: '确定',
      //       dangerouslyUseHTMLString: true,
      //     })
      //     return
      //   }

      if (!this.style_unit_fn()) {
        this.$alert(this.unit_msg.join('</br>'), '提示', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true,
        })
        return
      }
      //   var form = {
      //     unit_list: this.unit_list,
      //     potential_list: this.potential_list,
      //     all_LWSurgeries_list: this.mobile_ssl_list,
      //     drg: this.list_details.drg,
      //     dip: this.list_details.dip,
      //     zcnCode: this.list_details.zcnCode,
      //     representativeName: this.list_details.representativeName,
      //     hospitalName: this.list_details.hospitalName,
      //   }
      //   const { data } = await cataractnnvmp_mobilesubmit(this.mobile_ssl_list)
      const { data } = await cataractnnvmp_mobilesubmit(this.mobile_ssl_list, { zcncode: this.$route.query.zcncode }) // URL 查询参数 );
      if (data.code == 200) {
        this.$message.success(data.msg)
        this.back_url()
      } else {
        this.$message.error(data.msg)
      }
      //   console.log(JSON.stringify(form))
    },
    select_sjl(e) {
      //加载数据/添加产品 向table列表中添加数据
      console.log(e)
      const prdouct = this.prdouct
      var lastWeekSurgeries_list = [],
        list_details = this.list_details.details,
        select_product = e,
        all_LWSurgeries_list = this.all_LWSurgeries_list
      var jjsv_list = prdouct.filter((item) => item.Market.includes(select_product))[0].JJSV
      //   var jjsv_num = list_details.filter((item) => item.productCategory == select_product)
      var jjsv_num = list_details.filter((item) => jjsv_list.includes(item.product) || item.product == select_product)
      if (select_product == '景深延长(散+非散)') {
        this.delect_selsect('三焦点(散+非散)')
        console.log(list_details.filter((item) => item.product == '三焦点(散+非散)'))
        jjsv_num.push(list_details.filter((item) => item.product == '三焦点(散+非散)')[0])
      }
      if (select_product == '三焦点(散+非散)') {
        this.delect_selsect('景深延长(散+非散)')
        jjsv_num.push(list_details.filter((item) => item.product == '景深延长(散+非散)')[0])
      }
      this.delect_selsect(select_product)
      this.dialogVisible = false
      this.select_product = ''
      if (all_LWSurgeries_list.length > 0) {
        for (var i in all_LWSurgeries_list) {
          //   console.log(select_product)
          //   console.log(all_LWSurgeries_list[i])
          //   console.log(all_LWSurgeries_list[i].filter((item) => item.productCategory == select_product))
          if (all_LWSurgeries_list[i].filter((item) => item.productCategory == select_product).length > 0) {
            return
          }
        }
      }
      all_LWSurgeries_list.push(jjsv_num)
      this.all_LWSurgeries_list = all_LWSurgeries_list
    },
    delect_selsect(e) {
      //删除数据/删除产品 从产品下拉列表中删除数据
      var jjsv_select_product_list = this.jjsv_select_product_list
      let list = jjsv_select_product_list.filter((item) => item != e)
      this.jjsv_select_product_list = list
    },
    // select_sjl(e) {
    //   //加载数据/添加产品 向table列表中添加数据
    //   const prdouct = this.prdouct
    //   var lastWeekSurgeries_list = [],
    //     list_details = this.list_details.details,
    //     select_product = e,
    //     all_LWSurgeries_list = this.all_LWSurgeries_list
    //   var market_name = prdouct.filter((item) => item.JJSV.includes(select_product))
    //   var jjsv_num = list_details.filter((item) => item.product == select_product)[0]
    //   this.delect_selsect(select_product)
    //   this.dialogVisible = false
    //   this.select_product = ''
    //   if (all_LWSurgeries_list.length > 0) {
    //     for (var i in all_LWSurgeries_list) {
    //       if (all_LWSurgeries_list[i].filter((item) => market_name[0].JJSV.includes(item.product)).length > 0) {
    //         all_LWSurgeries_list[i].unshift(jjsv_num)
    //         return
    //       }
    //     }
    //   }
    //   lastWeekSurgeries_list.push(jjsv_num)
    //   market_name.filter((items) => {
    //     var market_num = list_details.filter((item) => item.product == items.Market[0])[0]
    //     lastWeekSurgeries_list.push(market_num)
    //   })
    //   this.all_LWSurgeries_list.push(lastWeekSurgeries_list)
    //   this.delect_selsect(select_product)
    // },
    // delect_selsect(e) {
    //   //删除数据/删除产品 从产品下拉列表中删除数据
    //   var jjsv_select_product_list = this.jjsv_select_product_list
    //   let list = jjsv_select_product_list.filter((item) => item.code != e)
    //   this.jjsv_select_product_list = list
    // },
    async cataractnnvmp_getjjsvproduct_fn() {
      const { data } = await cataractnnvmp_getjjsvproduct()
      //   this.jjsv_select_product_list = data.data
      //   let prdouct_list = data.data
      //   let mkt_prdouct = []
      //   for (var p in prdouct_list) {
      //     if (!mkt_prdouct.includes(prdouct_list[p].category) && prdouct_list[p].category != 'Others') {
      //       mkt_prdouct.push(prdouct_list[p].category)
      //     }
      //   }
      //   console.log(mkt_prdouct)
      //   this.jjsv_select_product_list = mkt_prdouct
      //   this.prdouct_JJSV = prdouct_list.map((item) => item.code)
      for (let s in this.list_details.details) {
        if (
          (this.list_details.details[s].lastWeekSurgeries || this.list_details.isReportedThisWeek) &&
          this.prdouct_JJSV.includes(this.list_details.details[s].product) &&
          this.list_details.details[s].productCategory != 'Others'
        ) {
          this.select_sjl(this.list_details.details[s].productCategory)
        }
      }
    },
    async cataractnnvmp_getmarketproduct_fn() {
      const { data } = await cataractnnvmp_getmarketproduct()
      this.market_select_product_list = data.data
    },
    total_pnl() {
      let sun = 0
      this.potential_list.forEach((item) => {
        // if (item.category == 'Market') {
        sun += Number(item.potential)
        // }
      })
      this.list_details.potential = sun
    },
    style_unit_fn() {
      this.unit_style_list = []
      this.unit_msg = []
      var unit_list = this.unit_list
      let nums = null
      let label_list = []
      let makt_label = []
      let jjsv_label = []
      unit_list.filter((item) => {
        if (item.Category == '景深延长(散+非散)' || item.Category == '三焦点(散+非散)') {
          label_list.push(item.Category)
          if (item.Market_contractQuantity != null && item.Market_contractQuantity != '') {
            nums += Number(item.Market_contractQuantity)
          }

          //   console.log(item.Market_contractQuantity)
          if (nums < item.JJSV_contractQuantity && nums != null && item.Category == '三焦点(散+非散)') {
            this.unit_style_list = [...this.unit_style_list, ...label_list]
            this.unit_msg.push('Market【景深延长(散+非散)+三焦点(散+非散】值不能小于 JJSV 对应值。')
          }
        } else {
          //   console.log(item.Market_contractQuantity)
          if (
            item.Market_contractQuantity < item.JJSV_contractQuantity &&
            item.Market_contractQuantity != null &&
            item.Market_contractQuantity != ''
          ) {
            this.unit_msg.push('Market【' + item.Category + '】值不能小于 JJSV 对应值。')
            this.unit_style_list.push(item.Category)
          }
        }
      })
      console.log(this.unit_style_list)
      if (this.unit_style_list.length > 0) {
        return false
      }
      return true
    },

    objectSpanMethod4({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1 && rowIndex < 5) {
        if (rowIndex % 5 === 0) {
          return {
            rowspan: 5,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    cellStyle4({ row, column, rowIndex, columnIndex }) {
      if (this.lastWeekSurgeries_style_list.includes(row.product) && column.label === '上月手术量') {
        return { backgroundColor: '#eca5a5' }
      }
    },
    cellStyle3({ row, column, rowIndex, columnIndex }) {
      if ((column.label === 'JJSV' || column.label === '全院总手术量') && rowIndex < 5) {
        return {
          'background-color': '#f6f9ff',
        }
      }
    },
    cellStyle2({ row, column, rowIndex, columnIndex }) {
      if (this.unit_style_list.includes(row.Category) && column.label === 'Market') {
        return { backgroundColor: '#eca5a5' }
      }
      if ((column.label === 'JJSV' || column.label === '全院总手术量') && rowIndex < 5) {
        return {
          'background-color': '#f6f9ff',
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1 && rowIndex < 5) {
        if (rowIndex % 5 === 0) {
          return {
            rowspan: 5,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    productCategories_fn(details) {
      // 重组数据用来显示unit和potential表格
      const prdouct = this.prdouct
      var list_unit = []
      var list_potential = []
      for (var i in prdouct) {
        var jjsv_num = details
          .filter((item) => prdouct[i].JJSV.includes(item.product))
          .reduce((sum, detail) => sum + (detail.contractQuantity || 0), 0)
        var market_num = details.filter((item) => prdouct[i].Market.includes(item.product))
        list_unit.push({
          Category: prdouct[i].Market[0],
          JJSV_contractQuantity: jjsv_num,
          Market_contractQuantity: market_num[0].contractQuantity,
          marketProductId: market_num[0].marketProductId,
        })
        list_potential.push({
          Category: prdouct[i].Market[0],
          potential: market_num[0].potential,
          marketProductId: market_num[0].marketProductId,
        })
      }
      console.log(list_potential)
      this.unit_list = list_unit
      this.potential_list = list_potential
    },
    async cataractnnvmp_mobiledetailed_fn(row, actualMonth) {
      const { data } = await cataractnnvmp_mobiledetailed({ zcncode: row, actualMonth: actualMonth })
      this.mobile_ssl_list = data.data
      if (!this.list_details.isReportedThisWeek) {
        if (this.mobile_ssl_list.totalNumber == 0) {
          this.mobile_ssl_list.totalNumber = ''
        }
        this.mobile_ssl_list.list.forEach((item) => {
          item.number = item.number
          if (item.number == 0) {
            item.number = ''
          }
        })
      }
    },
  },
  mounted() {
    const now = new Date()
    const currentMonth = now.getMonth() + 1
    const old_Month = now.getMonth()
    // this.now_Month = currentMonth
    // if (old_Month == 0) {
    //   this.old_Month = 12
    // } else {
    //   this.old_Month = old_Month
    // }
    localStorage.setItem('actualMonth', this.$route.query.actualMonth)
    var actualMonth = this.$route.query.actualMonth
    const date = new Date(actualMonth)
    if (isNaN(date)) return
    var displayMonth = date.getMonth() + 1
    this.old_Month = displayMonth
    console.log(displayMonth)
    var hco_list = JSON.parse(localStorage.getItem('hco_list'))
    this.list_details = hco_list
    this.cataractnnvmp_mobiledetailed_fn(this.$route.query.zcncode, this.$route.query.actualMonth)
    // this.productCategories_fn(hco_list.details)
    this.cataractnnvmp_getjjsvproduct_fn()
    this.cataractnnvmp_getmarketproduct_fn()
  },
}
</script>

<style>
.el-input__inner {
  padding: 10px 5px !important;
}
.el-collapse-item__header {
  font-size: 14px !important;
  font-weight: bold !important;
  /* background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: 1px solid rgb(203, 203, 203) !important; */
  padding-left: 5px !important;
}
.cell_class_name {
  text-align: center !important;
}
/* .el-input__inner {
  padding: 5px !important;
} */
.el-collapse-item__wrap {
  background-color: none !important;
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>
